export const tocHide = (): void => {
	const ele = document.getElementById('toc-trigger');
	if (ele) {
		ele.style.display = 'none';
	}
};

export const tocShow = (): void => {
	const ele = document.getElementById('toc-trigger');
	if (ele) {
		ele.style.display = '';
	}
};
